<div class="step-one">
    <div class="step-header">
        <div class="icon-wrapper">
            <i data-feather="truck"></i>
        </div>
        <h2>Opciones de Entrega</h2>
    </div>

    <div class="shipping-options">
        <!-- Option 1: Retiro en Sucursal -->
        <div class="shipping-card" [class.active]="step === 1">
            <div class="card-header" (click)="setStep(1)">
                <div class="header-left">
                    <div class="icon-wrapper">
                        <i data-feather="shopping-bag"></i>
                    </div>
                    <div class="title-group">
                        <h3>Retiro en Sucursal</h3>
                        <span class="badge success">Gratuito</span>
                    </div>
                </div>
                <div class="expand-icon" (click)="toggleStep(1, $event)">
                    <i [attr.data-feather]="step === 1 ? 'chevron-up' : 'chevron-down'"></i>
                </div>
            </div>

            <div class="card-content" *ngIf="step === 1">
                <div class="offices-grid">
                    <div *ngFor="let office of offices" class="office-item" [class.selected]="office.is_selected">
                        <mat-checkbox [(ngModel)]="office.is_selected" (change)="onChangeOffice($event)" [value]="office">
                            <div class="office-content">
                                <h4>{{ office.title }}</h4>
                                <div class="office-details">
                                    <p *ngIf="office.phone != '' && office.phone != null">
                                        <i data-feather="phone"></i>
                                        {{ office.phone }}
                                    </p>
                                    <p *ngIf="office.address != '' && office.address != null">
                                        <i data-feather="map-pin"></i>
                                        {{ office.address }}
                                    </p>
                                    <p *ngIf="office.hours != '' && office.hours != null">
                                        <i data-feather="clock"></i>
                                        {{ office.hours }}
                                    </p>
                                </div>
                            </div>
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <!-- Option 2: Envío a Venado Tuerto -->
        <div class="shipping-card" [class.active]="step === 2">
            <div class="card-header" (click)="setStep(2)">
                <div class="header-left">
                    <div class="icon-wrapper">
                        <i data-feather="truck"></i>
                    </div>
                    <div class="title-group">
                        <h3>Envío a Venado Tuerto</h3>
                        <span class="badge info">{{ getDeliveryPrice() | currency:'ARS':'symbol-narrow':'.0-0':'es-AR' }}</span>
                    </div>
                </div>
                <div class="expand-icon" (click)="toggleStep(2, $event)">
                    <i [attr.data-feather]="step === 2 ? 'chevron-up' : 'chevron-down'"></i>
                </div>
            </div>

            <div class="card-content" *ngIf="step === 2">
                <div class="delivery-form">
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Nombre y apellido</mat-label>
                            <input matInput [(ngModel)]="deliveryName" placeholder="Nombre completo">
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field flex-2">
                            <mat-label>Calle</mat-label>
                            <input matInput [(ngModel)]="deliveryAddress" placeholder="Nombre de la calle">
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field flex-1">
                            <mat-label>Número</mat-label>
                            <input matInput [(ngModel)]="deliveryNumber" maxlength="8" placeholder="N°">
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Piso / Departamento</mat-label>
                            <input matInput [(ngModel)]="deliveryFloor" placeholder="Piso o departamento (opcional)">
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Número de teléfono</mat-label>
                            <input matInput [(ngModel)]="deliveryCode" placeholder="Teléfono de contacto">
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <!-- Option 3: Envío con OCA -->
        <div class="shipping-card" [class.active]="step === 3">
            <div class="card-header" (click)="setStep(3)">
                <div class="header-left">
                    <div class="icon-wrapper">
                        <i data-feather="package"></i>
                    </div>
                    <div class="title-group">
                        <h3>Envío con OCA</h3>
                        <span class="badge warning">A cargo del comprador</span>
                    </div>
                </div>
                <div class="expand-icon" (click)="toggleStep(3, $event)">
                    <i [attr.data-feather]="step === 3 ? 'chevron-up' : 'chevron-down'"></i>
                </div>
            </div>

            <div class="card-content" *ngIf="step === 3">
                <div class="oca-disclaimer">
                    <i data-feather="info"></i>
                    <p><strong>Importante:</strong> El envío es a cargo del comprador y se abona cuando llega el paquete.</p>
                </div>

                <div class="oca-form">
                    <!-- Shipping Calculator Section -->
                    <div class="shipping-calculator-section">
                        <h3 class="section-title">Calculá el costo de envío</h3>
                        
                        <div class="calculator-input-group">
                            <mat-form-field appearance="outline" class="input-code-postal">
                                <mat-label>Código Postal</mat-label>
                                <input matInput [(ngModel)]="ocaZipCode" (keypress)="onlyNumbers($event)" placeholder="Ej: 1425">
                            </mat-form-field>

                            <button 
                                mat-raised-button 
                                color="primary" 
                                class="btn-calculate-shipping"
                                (click)="calculateOcaShipping()"
                                [disabled]="isCalculatingOcaShipping">
                                <mat-spinner *ngIf="isCalculatingOcaShipping" diameter="16"></mat-spinner>
                                <span *ngIf="!isCalculatingOcaShipping">
                                    <i data-feather="calculator"></i>
                                    Calcular
                                </span>
                            </button>
                        </div>

                        <!-- Shipping Result -->
                        <div *ngIf="ocaShippingResult" class="shipping-result success">
                            <div class="result-icon">
                                <i data-feather="check-circle"></i>
                            </div>
                            <div class="result-content">
                                <div class="result-price">{{ ocaShippingResult.total | currency:'ARS':'symbol-narrow':'.0-0':'es-AR' }}</div>
                                <div class="result-delivery">Llega en {{ ocaShippingResult.plazo_entrega }} {{ ocaShippingResult.plazo_entrega == 1 ? 'día hábil' : 'días hábiles' }}</div>
                            </div>
                        </div>
                        
                        <!-- Shipping Error -->
                        <div *ngIf="ocaShippingError" class="shipping-result error">
                            <div class="result-icon">
                                <i data-feather="alert-triangle"></i>
                            </div>
                            <div class="result-content">
                                <div class="result-message">{{ ocaShippingError }}</div>
                            </div>
                        </div>
                    </div>

                    <!-- Delivery Address Section -->
                    <div class="delivery-address-section" *ngIf="ocaShippingResult">
                        <h3 class="section-title">Datos de entrega</h3>

                        <div class="form-row">
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Nombre y apellido</mat-label>
                                <input matInput [(ngModel)]="ocaName" placeholder="Nombre completo del destinatario">
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field appearance="outline" class="form-field flex-2">
                                <mat-label>Calle</mat-label>
                                <input matInput [(ngModel)]="ocaStreet" placeholder="Nombre de la calle">
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-field flex-1">
                                <mat-label>Número</mat-label>
                                <input matInput [(ngModel)]="ocaNumber" (keypress)="onlyNumbers($event)" maxlength="8" placeholder="N°">
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Piso/Departamento (Opcional)</mat-label>
                                <input matInput [(ngModel)]="ocaFloor" placeholder="Ej: 3°A">
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Número de teléfono</mat-label>
                                <input matInput [(ngModel)]="ocaPhone" (keypress)="onlyNumbers($event)" placeholder="Teléfono de contacto">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Option 4: Otras opciones de envío -->
        <div class="shipping-card" [class.active]="step === 4">
            <div class="card-header" (click)="setStep(4)">
                <div class="header-left">
                    <div class="icon-wrapper">
                        <i data-feather="more-horizontal"></i>
                    </div>
                    <div class="title-group">
                        <h3>Otras opciones de envío</h3>
                        <span class="badge secondary">Pago en efectivo</span>
                    </div>
                </div>
                <div class="expand-icon" (click)="toggleStep(4, $event)">
                    <i [attr.data-feather]="step === 4 ? 'chevron-up' : 'chevron-down'"></i>
                </div>
            </div>

            <div class="card-content" *ngIf="step === 4">
                <div class="other-options-content">
                    <h4>¿Cómo coordino el pago del envío?</h4>
                    <ol>
                        <li>Al terminar tu compra, recibirás los datos de contacto.</li>
                        <li>Contactanos para acordar el lugar de entrega.</li>
                    </ol>
                    <div class="contact-info">
                        <i data-feather="phone"></i>
                        <p>Si tenés alguna duda, contactanos al <strong>(03462) 427715 - 421821</strong></p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="action-buttons">
        <button mat-stroked-button class="btn-back" [routerLink]="['/carrito-de-compras']">
            <i data-feather="arrow-left"></i>
            Volver
        </button>
        <button 
            mat-raised-button 
            color="primary" 
            class="btn-continue" 
            (click)="onClickContinue()"
            [disabled]="step === 0"
            [matTooltip]="step === 0 ? 'Debe seleccionar una opción de entrega' : ''">
            <i data-feather="lock"></i>
            Continuar
        </button>
    </div>
</div>
